// src/pages/ThankYouScreen.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaCheckCircle, FaHome, FaBoxOpen, FaWhatsapp } from "react-icons/fa";

const ThankYouScreen = () => {
  const navigate = useNavigate();
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const colors = ["#9b1f6c", "#542757", "#e9a8d2", "#c46fa5", "#f9eef5", "#fff"];
    const shapes = ["circle", "rect", "circle", "rect", "circle"];
    const items = Array.from({ length: 60 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      delay: Math.random() * 2.5,
      duration: 2.5 + Math.random() * 3,
      size: 6 + Math.random() * 10,
      color: colors[Math.floor(Math.random() * colors.length)],
      shape: shapes[Math.floor(Math.random() * shapes.length)],
      rotate: Math.random() * 360,
    }));
    setParticles(items);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

        :root {
          --mg: #9b1f6c;
          --mg-dark: #7a1756;
          --mg-light: #f9eef5;
          --mg-mid: #e9a8d2;
          --plum: #542757;
          --navy: #1a1830;
          --slate: #55536a;
          --line: #eceaf1;
          --bg: #f6f4fb;
          --white: #ffffff;
          --success: #16a34a;
          --radius: 12px;
          --shadow: 0 4px 24px rgba(84,39,87,.12);
          --shadow-lg: 0 16px 48px rgba(84,39,87,.18);
        }

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .ty-page {
          font-family: 'DM Sans', system-ui, sans-serif;
          background: var(--bg);
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 24px 16px;
          position: relative;
          overflow: hidden;
        }

        .ty-page::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(155,31,108,.10) 0%, transparent 70%);
          pointer-events: none;
          z-index: 0;
        }

        .ty-particles {
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: 0;
          overflow: hidden;
        }

        @keyframes fall {
          0%   { transform: translateY(-40px) rotate(0deg); opacity: 1; }
          80%  { opacity: 1; }
          100% { transform: translateY(110vh) rotate(720deg); opacity: 0; }
        }

        .ty-particle {
          position: absolute;
          top: 0;
          animation: fall linear forwards;
        }

        .ty-header {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          background: var(--white);
          border-bottom: 1px solid var(--line);
          padding: 16px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          z-index: 100;
          box-shadow: 0 2px 12px rgba(0,0,0,.06);
        }
        .ty-header__logo {
          font-family: 'Sora', sans-serif;
          font-size: 18px;
          font-weight: 800;
          color: var(--mg);
          letter-spacing: -.01em;
        }
        .ty-header__badge {
          display: flex;
          align-items: center;
          gap: 6px;
          background: #dcfce7;
          color: var(--success);
          font-size: 12px;
          font-weight: 700;
          padding: 5px 12px;
          border-radius: 99px;
        }

        .ty-steps {
          position: fixed;
          top: 57px;
          left: 0;
          right: 0;
          background: var(--white);
          border-bottom: 1px solid var(--line);
          padding: 12px 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0;
          z-index: 99;
        }
        .ty-step {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          font-weight: 600;
          color: #bbb;
        }
        .ty-step.done { color: var(--success); }
        .ty-step__num {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 2px solid currentColor;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          font-weight: 700;
          flex-shrink: 0;
        }
        .ty-step.done .ty-step__num {
          background: var(--success);
          border-color: var(--success);
          color: #fff;
        }
        .ty-step__sep {
          width: 32px;
          height: 2px;
          background: var(--success);
          margin: 0 8px;
          flex-shrink: 0;
        }

        /* ── MAIN CARD ── */
   /* ── MAIN CARD ── */
.ty-card {
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: 20px;
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 480px;
  padding: 40px 36px 36px;
  text-align: center;
  position: relative;
  z-index: 10;
  margin-top: 120px;
  margin-left: auto;
  margin-right: auto;
}

/* ── WEB VIEW: wider card ── */
@media (min-width: 768px) {
  .ty-card {
    max-width: 780px;
    padding: 56px 80px 52px;
    border-radius: 24px;
    margin-left: auto;
    margin-right: auto;
  }
  ...
}

          .ty-title {
            font-size: 36px !important;
          }

          .ty-subtitle {
            font-size: 16px !important;
            max-width: 520px !important;
          }

          .ty-timeline {
            max-width: 560px;
            margin-left: auto;
            margin-right: auto;
          }

          .ty-tl-line {
            max-width: 80px !important;
          }

          .ty-pills {
            gap: 14px;
          }

          .ty-pill {
            font-size: 13px;
            padding: 8px 18px;
          }

          .ty-btn-primary,
          .ty-btn-secondary {
            max-width: 420px;
            margin-left: auto;
            margin-right: auto;
          }

          .ty-icon-ring {
            width: 96px !important;
            height: 96px !important;
            margin-bottom: 28px !important;
          }
        }

        @media (min-width: 1200px) {
          .ty-card {
            max-width: 960px;
            padding: 64px 120px 60px;
          }
        }

        .ty-icon-ring {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: linear-gradient(135deg, var(--plum), var(--mg));
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 24px;
          box-shadow: 0 8px 24px rgba(155,31,108,.35);
          position: relative;
        }
        .ty-icon-ring::after {
          content: '';
          position: absolute;
          inset: -6px;
          border-radius: 50%;
          border: 2px solid rgba(155,31,108,.20);
        }

        @keyframes pulse-ring {
          0%   { transform: scale(1); opacity: .6; }
          100% { transform: scale(1.5); opacity: 0; }
        }
        .ty-icon-ring::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 50%;
          background: linear-gradient(135deg, var(--plum), var(--mg));
          animation: pulse-ring 1.8s ease-out infinite;
        }

        .ty-title {
          font-family: 'Sora', sans-serif;
          font-size: 26px;
          font-weight: 800;
          color: var(--navy);
          line-height: 1.2;
          margin-bottom: 10px;
          letter-spacing: -.02em;
        }
        .ty-title span { color: var(--mg); }

        .ty-subtitle {
          font-size: 14px;
          color: var(--slate);
          line-height: 1.6;
          margin-bottom: 28px;
          max-width: 320px;
          margin-left: auto;
          margin-right: auto;
        }

        .ty-pills {
          display: flex;
          gap: 10px;
          justify-content: center;
          margin-bottom: 28px;
          flex-wrap: wrap;
        }
        .ty-pill {
          display: flex;
          align-items: center;
          gap: 6px;
          background: var(--mg-light);
          color: var(--mg-dark);
          border: 1px solid rgba(155,31,108,.15);
          border-radius: 99px;
          padding: 6px 14px;
          font-size: 12px;
          font-weight: 600;
        }
        .ty-pill svg { font-size: 12px; }

        .ty-divider {
          height: 1px;
          background: var(--line);
          margin-bottom: 24px;
        }

        .ty-timeline {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          gap: 0;
          margin-bottom: 28px;
        }
        .ty-tl-step {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          flex: 1;
          max-width: 100px;
        }
        .ty-tl-dot {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: var(--mg-light);
          border: 2px solid rgba(155,31,108,.20);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          position: relative;
          z-index: 1;
        }
        .ty-tl-dot.active {
          background: linear-gradient(135deg, var(--plum), var(--mg));
          border-color: var(--mg);
          box-shadow: 0 4px 12px rgba(155,31,108,.30);
        }
        .ty-tl-label {
          font-size: 10px;
          font-weight: 600;
          color: var(--slate);
          text-align: center;
          line-height: 1.3;
        }
        .ty-tl-label.active { color: var(--mg); }
        .ty-tl-line {
          flex: 1;
          height: 2px;
          background: var(--line);
          margin-top: 15px;
          max-width: 40px;
        }
        .ty-tl-line.active { background: linear-gradient(90deg, var(--mg), rgba(155,31,108,.3)); }

        .ty-btn-primary {
          width: 100%;
          padding: 14px;
          background: linear-gradient(135deg, var(--plum), var(--mg));
          color: #fff;
          border: none;
          border-radius: 10px;
          font-family: 'Sora', sans-serif;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          box-shadow: 0 4px 16px rgba(155,31,108,.30);
          transition: filter .2s, transform .15s;
          letter-spacing: .01em;
          margin-bottom: 10px;
        }
        .ty-btn-primary:hover { filter: brightness(1.08); transform: translateY(-1px); }
        .ty-btn-primary:active { transform: scale(.98); }

        .ty-btn-secondary {
          width: 100%;
          padding: 13px;
          background: transparent;
          color: var(--mg);
          border: 1.5px solid rgba(155,31,108,.30);
          border-radius: 10px;
          font-family: 'Sora', sans-serif;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: background .2s, border-color .2s;
          letter-spacing: .01em;
        }
        .ty-btn-secondary:hover {
          background: var(--mg-light);
          border-color: var(--mg);
        }

        .ty-note {
          margin-top: 20px;
          font-size: 11px;
          color: var(--slate);
          line-height: 1.6;
        }
        .ty-note a {
          color: var(--mg);
          font-weight: 600;
          text-decoration: none;
        }

        @media (max-width: 540px) {
          .ty-card {
            padding: 32px 20px 28px;
            margin-top: 110px;
            border-radius: 16px;
          }
          .ty-title { font-size: 22px; }
          .ty-header { padding: 14px 16px; }
          .ty-steps { top: 53px; }
        }

        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      {/* Confetti particles */}
      <div className="ty-particles">
        {particles.map((p) => (
          <div
            key={p.id}
            className="ty-particle"
            style={{
              left: `${p.x}%`,
              animationDuration: `${p.duration}s`,
              animationDelay: `${p.delay}s`,
            }}
          >
            {p.shape === "circle" ? (
              <div style={{
                width: p.size,
                height: p.size,
                borderRadius: "50%",
                background: p.color,
                opacity: 0.85,
              }} />
            ) : (
              <div style={{
                width: p.size * 0.7,
                height: p.size * 1.2,
                background: p.color,
                transform: `rotate(${p.rotate}deg)`,
                borderRadius: 2,
                opacity: 0.75,
              }} />
            )}
          </div>
        ))}
      </div>

      {/* Header */}
      <header className="ty-header">
        <div className="ty-header__logo">HLC Checkout</div>
        <div className="ty-header__badge">
          <FaCheckCircle size={11} />
          Order Placed
        </div>
      </header>

      {/* Steps — all done */}
      <div className="ty-steps">
        {["Cart", "Details", "Confirm"].map((label, i) => (
          <React.Fragment key={label}>
            {i > 0 && <div className="ty-step__sep" />}
            <div className="ty-step done">
              <div className="ty-step__num">✓</div>
              <span style={{ fontSize: 12, fontWeight: 600 }}>{label}</span>
            </div>
          </React.Fragment>
        ))}
      </div>

      {/* Main card */}
      <motion.div
        className="ty-card"
        initial={{ opacity: 0, y: 32, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      >
        {/* Icon */}
        <motion.div
          className="ty-icon-ring"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200, damping: 14 }}
        >
          <FaCheckCircle size={32} color="#fff" style={{ position: "relative", zIndex: 1 }} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.4 }}
        >
          <h1 className="ty-title">
            Thank you for<br />
            <span>choosing HLC!</span>
          </h1>
          <p className="ty-subtitle">
            Your order has been placed successfully. Our team will reach out to you shortly to confirm your delivery.
          </p>
        </motion.div>

        {/* Pills */}
        <motion.div
          className="ty-pills"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.4 }}
        >
          <div className="ty-pill">
            <FaBoxOpen />
            Order Confirmed
          </div>
          <div className="ty-pill">
            💵 Cash on Delivery
          </div>
        </motion.div>

        <div className="ty-divider" />

        {/* Order status timeline */}
        <motion.div
          className="ty-timeline"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.4 }}
        >
          <div className="ty-tl-step">
            <div className="ty-tl-dot active">✓</div>
            <div className="ty-tl-label active">Order<br />Placed</div>
          </div>
          <div className="ty-tl-line active" />
          <div className="ty-tl-step">
            <div className="ty-tl-dot" style={{ fontSize: 16 }}>📦</div>
            <div className="ty-tl-label">Being<br />Packed</div>
          </div>
          <div className="ty-tl-line" />
          <div className="ty-tl-step">
            <div className="ty-tl-dot" style={{ fontSize: 16 }}>🚚</div>
            <div className="ty-tl-label">Out for<br />Delivery</div>
          </div>
          <div className="ty-tl-line" />
          <div className="ty-tl-step">
            <div className="ty-tl-dot" style={{ fontSize: 16 }}>🏠</div>
            <div className="ty-tl-label">Delivered</div>
          </div>
        </motion.div>

        <div className="ty-divider" />

        {/* Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.4 }}
        >
          <button className="ty-btn-primary" onClick={() => navigate("/", { replace: true })}>
            <FaHome size={14} />
            Back to Home
          </button>
          <button
            className="ty-btn-secondary"
            onClick={() => window.open("https://wa.me/923702961896", "_blank")}
          >
            <FaWhatsapp size={14} />
            Contact Us on WhatsApp
          </button>
        </motion.div>

        <p className="ty-note">
          Questions? Email us at <a href="mailto:info@hlcpk.com">info@hlcpk.com</a>
        </p>
      </motion.div>
    </>
  );
};

export default ThankYouScreen;